// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/voice/components/media_player/MediaTimeDisplay.module.css';
import {formatDuration} from '@app/vendor/date_utils/DateDuration';
import {useLingui} from '@lingui/react/macro';
import {clsx} from 'clsx';

interface MediaTimeDisplayProps {
	currentTime: number;
	duration: number;
	size?: 'small' | 'medium' | 'large';
	compact?: boolean;
	className?: string;
}
export function MediaTimeDisplay({
	currentTime,
	duration,
	size = 'medium',
	compact = false,
	className,
}: MediaTimeDisplayProps) {
	const {t} = useLingui();
	const currentFormatted = formatDuration(currentTime);
	const durationFormatted = formatDuration(duration);
	return (
		<div
			className={clsx(styles.container, styles[size], compact && styles.compact, className)}
			aria-label={t`Time: ${currentFormatted} of ${durationFormatted}`}
			role="group"
		>
			<span className={styles.time}>{currentFormatted}</span>
			{!compact && (
				<>
					<span className={styles.separator}>/</span>
					<span className={clsx(styles.time, styles.duration)}>{durationFormatted}</span>
				</>
			)}
		</div>
	);
}
